<template>
  <video
    class="video"
    id="player"
    controls
  />
</template>

<script>
  export default {
    name: 'Video',
    props: [
      'video'
    ],
    mounted() {
      var video = document.querySelector('#player');

      if (Hls.isSupported()) {
        var hls = new Hls();
      
        hls.loadSource(this.video);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED,function() {
          // video.play();
        });
      }
      
      plyr.setup(video);
    }
  }
</script>

<style lang="scss">
  .plyr {
    margin-bottom: 15px;

    span {
      margin-bottom: 0;
    }

    .plyr__time--current {
      color: white;
    }
  }
</style>
